import React from 'react';
import Icon from '../../../components/AppIcon';

const CategoryFilter = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <div className="bg-card rounded-xl shadow-md p-3 md:p-4 lg:p-6 mb-4 md:mb-6 lg:mb-8">
      <h2 className="text-base md:text-lg lg:text-xl font-bold text-foreground mb-3 md:mb-4">Categories</h2>
      <div className="flex gap-2 md:gap-3 overflow-x-auto pb-2 scrollbar-hide">
        {categories?.map((category) => (
          <button
            key={category?.id}
            onClick={() => onCategoryChange(category?.id)}
            className={`flex-shrink-0 flex items-center gap-2 px-3 py-2 md:px-4 md:py-2.5 rounded-lg font-semibold text-sm md:text-base transition-all ${
              activeCategory === category?.id
                ? 'bg-primary text-primary-foreground shadow-md'
                : 'bg-muted text-muted-foreground hover:bg-muted/80'
            }`}
          >
            <Icon name={category?.icon} size={18} />
            <span>{category?.name}</span>
            <span className="text-xs opacity-75">({category?.count})</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default CategoryFilter;